import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'
import Gate from '../'
import * as Constants from 'application/constants'

// Map routes between Ergosense and Terrasense equivalents
const ROUTE_MAPPINGS = {
    ergosense: {
        [Constants.PATH.TERRASENSE_HOME]: Constants.PATH.HOME,
        [Constants.PATH.REPORTING_ANALYTICS_TERRASENSE]: Constants.PATH.REPORTING_ANALYTICS,
        [Constants.PATH.PROPERTY_VIEWER]: Constants.PATH.WORKSPACE_VIEWER,
        [Constants.PATH.TERRASENSE_PROPERTIES]: Constants.PATH.WORKSPACE_BUILDING,
        [Constants.PATH.TERRASENSE_BLOCKS]: Constants.PATH.WORKSPACE_FLOORS,
        [Constants.PATH.TERRASENSE_AREAS]: Constants.PATH.WORKSPACE_AREAS

    },
    terrasense: {
        [Constants.PATH.HOME]: Constants.PATH.TERRASENSE_HOME,
        [Constants.PATH.REPORTING_ANALYTICS]: Constants.PATH.REPORTING_ANALYTICS_TERRASENSE,
        [Constants.PATH.WORKSPACE_VIEWER]: Constants.PATH.PROPERTY_VIEWER,
        [Constants.PATH.WORKSPACE_BUILDING]: Constants.PATH.TERRASENSE_PROPERTIES,
        [Constants.PATH.WORKSPACE_FLOORS]: Constants.PATH.TERRASENSE_BLOCKS,
        [Constants.PATH.WORKSPACE_AREAS]: Constants.PATH.TERRASENSE_AREAS
    }
}

const CompanyGate = ({ children, ergosenseOnly, terrasenseOnly }) => {
    const companyType = String(useSelector((state) =>
        state._user?.impersonate?.companyType || state.auth?.payload?.companyType || []
    ))
    const authed = useSelector((state) => !!state.auth?.authed)
    const location = useLocation()

    const isTerrasenseUser = companyType.trim() === "3"
    const isErgosenseUser = !isTerrasenseUser

    let open = true
    let redirectPath = null

    // Restrict Ergosense routes from Terrasense users
    if (authed && ergosenseOnly && isTerrasenseUser) {
        open = false
        redirectPath = ROUTE_MAPPINGS.terrasense[location.pathname] || Constants.PATH.TERRASENSE_HOME
        console.log(`[CompanyGate] Redirecting Terrasense user from Ergosense route: ${location.pathname}`);
    }
    // Restrict Terrasense routes from Ergosense users
    else if (authed && terrasenseOnly && isErgosenseUser) {
        open = false
        redirectPath = ROUTE_MAPPINGS.ergosense[location.pathname] || Constants.PATH.HOME
        console.log(`[CompanyGate] Redirecting Ergosense user from Terrasense route: ${location.pathname}`, { companyType, authed, terrasenseOnly, isErgosenseUser });
    }

    return (
        <Gate
            open={open}
            fallback={<Redirect to={{ pathname: redirectPath || Constants.PATH.HOME, search: location.search }} />}
        >
            {children}
        </Gate>
    )
}

export default CompanyGate
